
/**
 * Defines the expected part size when doing multipart upload in browser/Premiere panel
 */
export const UPLOAD_MAX_PART_SIZE = 50 * 1024 * 1024;

/**
 * Threshold when deciding if we use simple PUT or multipart upload in browser/Premiere panel
 */
export const UPLOAD_MULTIPART_THRESHOLD = 100 * 1024 * 1024;

